// extracted by mini-css-extract-plugin
export default {"status-container":"pet-stats_status-container__If8u9","status-item":"pet-stats_status-item__Vol0K","odd":"pet-stats_odd__4x9Qr"};